import React from 'react';
import { get } from 'lodash';
import DateInput from "./DateInput";
import { TextInput, TextBoxInput, FileInput } from "../../containers/StewardAssetEditPage/ValidationWrapper";
import CheckBoxInput from "./CheckBoxInput";
import NumberInput from "./NumberInput";

import pageStyles from "../../containers/StewardAssetEditPage/StewardAssetEditPage.scss";

export const Types = {
  TEXTBOX: "TEXTBOX",
  TEXT: "TEXT",
  CHECKBOX: "CHECKBOX",
  DATE: "DATE",
  NUMBER: "NUMBER",
  FILE: "FILE",
  BLANK: "BLANK"
};


export const InputPicker = (input, ref, value, onChange) => {
  switch (input.type) {
    case Types.TEXT:
      return (
        <TextInput
          key={input.field}
          value={get(value, input.field)}
          onChange={onChange}
          changeRef={ref}
          required={input.required}
          label={input.label}
          field={input.field} />
      );
    case Types.NUMBER:
      return (
        <NumberInput
          key={input.field}
          value={get(value, input.field)}
          onChange={onChange}
          required={input.required}
          label={input.label}
          field={input.field} />
      );
    case Types.TEXTBOX:
      return (
        <TextBoxInput
          key={input.field}
          value={get(value, input.field)}
          onChange={onChange}
          changeRef={ref}
          required={input.required}
          fullWidth={input.fullWidth}
          label={input.label}
          maxChar={input.maxChar}
          field={input.field} />
      );
    case Types.CHECKBOX:
      return (
        <CheckBoxInput
          key={input.field}
          value={get(value, input.field)}
          onChange={onChange}
          label={input.label}
          field={input.field} />
      );
    case Types.DATE:
      return (
        <DateInput
          key={input.field}
          value={get(value, input.field)}
          onChange={onChange}
          required={input.required}
          fullWidth={input.fullWidth}
          label={input.label}
          field={input.field} />
      );
    case Types.FILE:
      return (
        <FileInput
          key={input.field}
          value={get(value, input.field)}
          changeRef={ref}
          onChange={onChange}
          required={input.required}
          label={input.label}
          fileTypes={input.fileTypes}
          field={input.field} />
      );
    case Types.BLANK:
      return (
        <div key={input.field} className={pageStyles["half-width"]}>&nbsp;</div>
      );
    default:
      return null;
  }
};
